<template>
      <b-container fluid>
        <!-- ACTION BAR -->
          <b-col cols="12" class="d-flex justify-content-end mt-3">
          <b-button class="btnFilter_2 mr-2" @click="newTransaction">
            <i class="fa-light fa-file-import"></i>
            {{ $t('mandate.import_bulk') }}
          </b-button>
            <!-- Export -->
            <b-button class="btnFilter_2 mr-2 w-100" @click="exportCollectionBulk">
              <i class="fa-light fa-upload"></i>
              {{ $t('mandate.export') }}
            </b-button>
            <!-- Filter toggle -->
            <b-button class="btnFilter_2 mr-2 w-100" @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
            <!-- Refresh -->
            <b-button class="btnFilter_2 w-100" @click="onRefresh">
              <i class="fa-light fa-rotate-right"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>

        <hr class="mx-auto" />

        <!-- FILTERS -->
        <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center">
          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('mandate.file_name') }}</span>
            <input v-model.trim="FileName" class="filter-item-content w-100" style="padding:0.13rem" :placeholder="$t('mandate.file_name')" />
          </b-col>

          <b-col cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_begin') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD HH:mm:ss"
                periodFull
                id="filter-datebegin"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilter}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date2')"
                inputIcon="fa-solid fa-calendar"
                v-model="dateBeginFilter"/>
            </div>
          </b-col>

          <b-col cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_end') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD HH:mm:ss"
                periodFull
                id="filter-dateend"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilter}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date2')"
                inputIcon="fa-solid fa-calendar"
                v-model="dateEndFilter"/>
            </div>
          </b-col>

          <b-row class="min-w-100 justify-content-end align-items-center">

              <b-col cols="12" class="d-flex justify-content-end mt-3">
                <b-button class="btnFilter_2 mr-2 w-100" @click="clearFilterFields" :disabled="!hasInputFilter">
                  {{ $t('common.rst') }}
                </b-button>
                <b-button class="btnFilter_2 w-100" @click="onRefresh">
                  {{ $t('common.srch') }}
                </b-button>
              </b-col>
          </b-col>
            </b-row>
        </b-row>

        <hr class="mx-auto mb-4" v-if="displayFilter"/>
        <!-- TABLE -->
        <b-row>
          <b-col cols="12" class="mx-auto mb-4">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsCollectionBulk.length > 0"
                hover
                striped
                responsive
                class="table table-striped"
                style="margin-bottom:0"
                :items="listItemsCollectionBulk"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                :key="refreshKey"
                :empty-text="$t('common.security.no_result')"
                @row-clicked="onRowClicked">
                <template #cell(FileName)="data">
                  <span v-if="data.value !== ''"> {{ data.value }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(CreationDate)="data">
                  {{ formatDate(data.value) }}
                </template>
                <template #cell(NbLinesTotal)="data">
                  <span v-if="data.value !== ''"> {{ data.value }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(NbLinesTreated)="data">
                  <span v-if="data.value !== ''"> {{ data.value }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(actions)="{ item }">
                  <b-link @click.stop.prevent="onRowClicked(item)" class="text-decoration-none">
                    {{ $t('mandate.view_details') }}
                  </b-link>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </b-container>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import Spinner from "@/components/common/spinner.vue"
import Pagination from '@/components/common/pagination.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import moment from 'moment-timezone'

export default {
  name: 'MandateTransactionsBulk',
  components: {
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    spinner: Spinner,
    'cm-pagination': Pagination,
  },
  data () {
    return {
      activateSpinner: false,
      CollectionBulkListExport: {},
      dateBeginFilter: null,
      dateEndFilter: null,
      displayFilter: true,
      fields: [
        { key: 'FileName', label: this.$t('mandate.file_name'), sortable: true, class: 'text-center' },
        { key: 'CreationDate', label: this.$t('mandate.date_action'), sortable: true, class: 'text-center' },
        { key: 'NbLinesTotal', label: this.$t('mandate.nb_lines_total'), sortable: true, class: 'text-center' },
        { key: 'NbLinesTreated', label: this.$t('mandate.nb_lines_treated'), sortable: true, class: 'text-center' },
        { key: 'actions', label: this.$t('mandate.actions'), class: 'text-center' }
      ],
      FileName: '',
      filterConditions: {},
      listItemsCollectionBulk: [],
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
      timezone: '+00:00'
    }
  },
  created() {
    this.timezone = moment.tz.guess()

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getCollectionBulk(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },
  computed: {
    hasInputFilter () {
      return !!this.FileName || this.dateBeginFilter || this.dateEndFilter
    }
  },
  methods: {
    newTransaction () {
        loadPage(this, {
          url: '/formpagesdd/cdtr/bulk/'
        })
    },
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getCollectionBulk()
    },
    clearFilterFields () {
      this.FileName = ''
      this.dateBeginFilter = null
      this.dateEndFilter = null
    },
    convertToISOStringFormat(dateTimeStr) {
      if (!dateTimeStr) return ''
      return dateTimeStr.replace(' ', 'T')
    },
    exportCollectionBulk () {
      let that = this
      let params = {
        FileName: this.FileName || '',
        StartDate: this.dateBeginFilter,
        EndDate: this.dateEndFilter
      }
      this.$engine.Collection.getCollectionBulk(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.CollectionBulk.length

        this.CollectionBulkListExport = resp.data.CollectionBulk

        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
        let firstLine = this.$t('mandate.file_name') + ';' +
          this.$t('mandate.date_action') + ';' +
          this.$t('mandate.nb_lines_total') + ';' +
          this.$t('mandate.nb_lines_treated') + '\r\n'
        let lines = ''
        for (var i = 0; i < this.CollectionBulkListExport.length; i++) {
          let result = this.CollectionBulkListExport[i]
          lines += result.FileName + ';' +
                   result.CreationDate + ';' +
                   result.NbLinesTotal + ';' +
                   result.NbLinesTreated + '\r\n'
        }
        let data = firstLine + lines
        this.$f7.hidePreloader()
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = this.$t('Webheader.collections_list') + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    formatCurrency (n) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
    },
    formatDate(dateIso) {
      return dateIso.replace("T", " ")
    },
    getCollectionBulk(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        FileName: this.FileName || '',
        StartDate: this.convertToISOStringFormat(this.dateBeginFilter),
        EndDate: this.convertToISOStringFormat(this.dateEndFilter),
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.Collection.getCollectionBulk(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.CollectionBulk.length

        let CollectionListBulk = {}

        CollectionListBulk = resp.data.CollectionBulk

        that.updateCollectionBulk(CollectionListBulk)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getCollectionBulk()
    },
    onRowClicked(item) {
      if (item && item.IdCollectionBulk) {
        loadPage(this, { url: '/mandatetransactionsbulk/details/' + item.IdCollectionBulk + '?IdCollectionBulk=' + item.IdCollectionBulk })
      }
    },
    refreshList () {
      this.page = 1
      this.transactions = this.transactions.slice()
      this.applyFilter()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'FileName',
        'CreationDate',
        'NbLinesTotal',
        'NbLinesTreated'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateCollectionBulk(CollectionListBulk) {
      this.listItemsCollectionBulk = CollectionListBulk
    }
  }
}
</script>

<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
